module.exports = __webpack_public_path__ + "img/search.60d8eb05.png";